import api from '../api-methods'

const proxyApi = process.env.VUE_APP_ENV === 'local' ? '/proxy_api' : process.env.VUE_APP_API

const inbox = {
	getAllApply: payload => {
		return api.get(proxyApi + '/v3/resume_hr_permissions', payload)
	},
	applyOperate: (permission_id, payload) => {
		return api.post(proxyApi + `/v3/resume_hr_permissions/${ permission_id }`, payload)
	}
}
export default inbox
